<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title}}</myhead>

  <div class="myField mt30">
    <div v-if="!$route.path.includes('register')">
      <van-field type="text" v-model="mobile" label="手机号:" placeholder="请输入手机号" autocomplete="off" />
      <div class="flex">
        <div class="width65"><van-field type="text" v-model="smscode" placeholder="请填写验证码" label="验证码:" style="padding-right:10px" name="yzm" autocomplete="off"/></div>
        <div><send-sms :mobile="mobile" :typeid="3">获取验证码</send-sms></div>
        <input type="password" value="123" style="display: none">
      </div>
    </div>
    
    <div>
      <div class="flex van-cell van-field myvan">
        <label for="">设置密码:</label>
        <div class="van-field__body myvan-field__body">
          <input type="text" style="width:0;height:0">
          <input type="password" value="123" style="width:0;height:0">
          <input type="text" @input="cs" v-model="password" autocomplete="off" placeholder="请输入密码" class="textrepa" style="position:absolute;">
          <!-- <input ref="pa"  type="password" v-model="password" @blur="check(1)" name="password1" id="pa" label="设置密码:" placeholder="请填写密码"  autocomplete="off" > -->
        </div>
      </div>
      <!-- <van-field v-model="password" @blur="check(1)" type="password" name="password1" id="pa" label="设置密码:" placeholder="请填写密码"  autocomplete="none" spellcheck="false"/> -->
      <p class="Cred ml120 mb15 size12">仅支持数字、字母、下划线</p>
      <div class="flex van-cell van-field myvan">
        <label for="">确认密码:</label>
        <div class="van-field__body myvan-field__body">
          <input type="text" style="width:0;height:0">
          <input type="password" value="123" style="width:0;height:0">
          <input type="text" ref="textrepa" @input="cs2"  v-model="cpassword" autocomplete="off" placeholder="请输入密码" class="textrepa" style="position:absolute;">
          <!-- <input ref="repa"  v-model="cpassword"  @blur="check(2)" type="password" name="password1" id="repa" label="确认密码:" placeholder="请确认密码"  autocomplete="off" > -->
        </div>
      </div>
      <!-- <input type="text" v-model="cspassword" @input="cs" style="font-size: 36px;height: 25px"> -->
      <!-- <van-field v-model="cpassword"  @blur="check(2)" type="password" name="password1" id="repa" label="确认密码:" placeholder="请确认密码"  autocomplete="none" spellcheck="false"/> -->
      <p class="Cred ml120 mb15 size12" v-show="error">{{error}}</p>
    </div>
  </div>
  <div class="pad15 mt60">
    <van-button type="primary" round block @click="next">确认</van-button>
  </div>


</template>

<script>
import SendSms from "@/components/SendSms.vue";
export default {
  components:{'send-sms':SendSms
  },
  data(){
    return {
      error:"",//
      smscode:'',
      mobile:'',
      cpassword:'',
      password:'',
      cspassword: '',//可删
      copypassword: '',//可删,实际上password的值
      copypassword2: '',//可删,实际上cpassword的值
    }
  },
  methods:{
    check(step=2){
      if(this.copypassword2 != this.copypassword && step==2){
        this.error = "两次输入密码不一致，请重新输入";
      }else if(this.copypassword2.length<6 && step==2){
        this.error = "密码长度6-20位"
      }else{
        this.error = ''
      }
    },
    next(){
      if(this.copypassword2 != this.copypassword){
        return this.error = "两次输入密码不一致，请重新输入";
      }else{
        this.error = ''
      }
      if(this.$route.path.includes("register")){
        this.ajax.post("users/registerpwd",{  //users/setpass
          id:this.$store.state.loginInfo.id,
          password:this.copypassword,
          cpassword:this.copypassword2
        }).then(()=>{
          this.$router.push({ path:'/register/name' })
        })
      }else{
        this.ajax({
          method:"post",
          url:"users/setpass",
          data:{
            mobile:this.mobile,
            smscode:this.smscode,
            password:this.copypassword,
            cpassword:this.copypassword2
          },
          myData:{
            showMsg:true
          }
        }).then(()=>{
          this.$router.back();
        })
      }
    },
    cs(e) {
      if(this.copypassword.length < this.password.length) {//增加
        const inputEnd = e.target.selectionEnd //输入结束的位置
        const inputLen = this.password.length - this.copypassword.length //输入结束时增加的长度
        const inputWay = inputEnd - inputLen //输入的位置
        const cloneCopyPasswordStr = this.password.slice(inputWay,inputEnd) //截取输入的内容
        let csstr = ''
        const cloneCopyPasswordArr = this.copypassword.split('') //将copy字符串转为数组
        cloneCopyPasswordArr.splice(inputWay,0,cloneCopyPasswordStr) //将输入的内容插入到数组中
        cloneCopyPasswordArr.forEach(item => { //数组拼接成字符串
          csstr += item
        })
        this.copypassword = csstr //将输入最终值赋予实际存储的变量copypassword
        this.password = ''
        csstr.split('').forEach(() => { //将cspassword转为·
          this.password+='·'
        })
      } else {//减少
        const inputEnd = e.target.selectionEnd //获取减少结束的位置
        const inputLen = this.copypassword.length - this.password.length //输入结束时减少的长度
        const inputWay = inputEnd + inputLen //删除时的位置
        const cloneCopyPasswordStr = this.copypassword.slice(inputEnd,inputWay) //截取删除的内容
        console.log(cloneCopyPasswordStr)
        let csstr = ''
        const cloneCopyPasswordArr = this.copypassword.split('') //将copy字符串转为数组
        cloneCopyPasswordArr.splice(inputEnd,inputLen) //删除减少的内容
        cloneCopyPasswordArr.forEach(item => { //数组拼接成字符串
          csstr += item
        })
        this.copypassword = csstr //将输入最终值赋予实际存储的变量copypassword
        this.password = ''
        csstr.split('').forEach(() => { //将cspassword转为·
          this.password+='·'
        })
      }
    },
    cs2(e) {
      if(this.copypassword2.length < this.cpassword.length) {//增加
        const inputEnd = e.target.selectionEnd //输入结束的位置
        const inputLen = this.cpassword.length - this.copypassword2.length //输入结束时增加的长度
        const inputWay = inputEnd - inputLen //输入的位置
        const cloneCopyPasswordStr = this.cpassword.slice(inputWay,inputEnd) //截取输入的内容
        let csstr = ''
        const cloneCopyPasswordArr = this.copypassword2.split('') //将copy字符串转为数组
        cloneCopyPasswordArr.splice(inputWay,0,cloneCopyPasswordStr) //将输入的内容插入到数组中
        cloneCopyPasswordArr.forEach(item => { //数组拼接成字符串
          csstr += item
        })
        this.copypassword2 = csstr //将输入最终值赋予实际存储的变量copypassword
        this.cpassword = ''
        csstr.split('').forEach(() => { //将cspassword转为·
          this.cpassword+='·'
        })
      } else {//减少
        const inputEnd = e.target.selectionEnd //获取减少结束的位置
        const inputLen = this.copypassword2.length - this.cpassword.length //输入结束时减少的长度
        const inputWay = inputEnd + inputLen //删除时的位置
        const cloneCopyPasswordStr = this.copypassword2.slice(inputEnd,inputWay) //截取删除的内容
        console.log(cloneCopyPasswordStr)
        let csstr = ''
        const cloneCopyPasswordArr = this.copypassword2.split('') //将copy字符串转为数组
        cloneCopyPasswordArr.splice(inputEnd,inputLen) //删除减少的内容
        cloneCopyPasswordArr.forEach(item => { //数组拼接成字符串
          csstr += item
        })
        this.copypassword2 = csstr //将输入最终值赋予实际存储的变量copypassword
        this.cpassword = ''
        csstr.split('').forEach(() => { //将cspassword转为·
          this.cpassword+='·'
        })
      }
    }
    // textrepa() {
    //   console.log(1)
    //   this.$refs.textrepa.style.zIndex = '-1'
    //   // this.$refs.repa.focus()
    // },
    // textoutrepa() {
    //   this.$refs.textrepa.style.zIndex = '1'
    //   // this.$refs.repa.blur()
    // }
    // pa() {
    //   if(this.password == '') {
    //     this.$refs.pa.type = 'text'
    //     console.log(this.$refs.pa)
    //     this.$refs.pa.autocomplete = 'off'
    //   }else {
    //     this.$refs.pa.type = 'password'
    //     this.$refs.pa.blur()
    //     this.$refs.pa.focus()
    //   }
    // },
    // repa() {
    //   console.log(this.cpassword.length)
    //   if(this.cpassword == '') {
    //     this.$refs.repa.type = 'text'
    //     this.$refs.repa.autocomplete = 'off'
    //   }else {
    //     this.$refs.repa.type = 'password'
    //     this.$refs.repa.blur()
    //     this.$refs.repa.focus()
    //   }
    // }
  },
  // watch: {
  //   password() {
  //     if(this.password == '') {
  //       this.$refs.pa.type = 'text'
  //       this.$refs.pa.autocomplete = 'off'
  //     }
  //   },
  //   cpassword() {
  //     if(this.cpassword == '') {
  //       this.$refs.repa.type = 'text'
  //       this.$refs.repa.autocomplete = 'off'
  //     }
  //   }
  // }
}
</script>

<style scoped>
.myvan label {
  width: 64px;
  text-align: right;
  margin-right: 12px;
}
.myvan-field__body {
  position: relative;
  flex: 1;
}
/* .van-field__body .textrepa {
  box-shadow: none;
  background: unset;
  background-color: transparent!important;
  caret-color:rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, 0);
  border: 0;
  outline: 0;
  letter-spacing: 5px;
}
.van-field__body input[type="password"] {
  letter-spacing: 0px;
}
.van-field__body .textrepa::placeholder {
  color: rgba(0, 0, 0, 0);
  font-size: 14px;
} */
</style>
